export const rotationClassList = [ "-rotate-3", "-rotate-2", "-rotate-1", "rotate-0", "rotate-1", "rotate-2", "rotate-3" ];
